<template>
  <div v-if="isNewDesign" class="quiz-wrapper">
    <!-- HEADER + BANNER -->
    <div class="banner-wrapper">
      <!-- Header -->
      <div class="quiz-header-new-1">
        <p class="quiz-title">Quiz</p>
        <!-- <p class="quiz-close" @click="handleBack">X</p> -->
        <div>
          <img
            v-on:click="handleBack()"
            src="@/assets/Close-1.png"
            style="width: 22px; height: 22px; cursor: pointer"
            alt=""
          />
        </div>
      </div>

      <!-- Banner -->
      <img :src="bannerUrl" class="quiz-banner" />
    </div>

    <!-- WHITE BACKGROUND PNG SECTION -->
    <div
      class="quiz-content-bg"
      :style="{ backgroundImage: `url(${quizBackgroundImage})` }"
    >
      <!-- PROGRESS BAR -->
      <div class="quiz-progress-row">
        <div class="timer-box">
          <img src="@/assets/timer-clock.png" />
          <p style="margin: 0px !important;">
            {{ Math.floor(Math.max(0, qtime) / 1000 / 60) }}m:
            {{ Math.floor((Math.max(0, qtime) / 1000) % 60) }}s
          </p>
        </div>

        <div
          v-for="(q, index) in quizData"
          :key="index"
          class="progress-bar-block"
          :style="{
            backgroundColor:
              quizNo > index
                ? '#70b865'
                : quizNo === index
                ? 'black'
                : '#f2f3f6'
          }"
        ></div>

        <p class="progress-count">{{ quizNo + 1 }}/{{ quizData.length }}</p>
      </div>

      <!-- QUESTION -->
      <div
        class="question-block-new"
        :class="{ 'question-answered': nextQuiz }"
      >
        <p class="question-text">
          {{ quizData[quizNo] ? quizData[quizNo].question : "" }}
        </p>

        <!-- OPTIONS -->
        <div class="option-main-div">
          <div
            v-for="(item, index) in currentQuizQuest"
            :key="index"
            class="options-block-new"
            :class="{
              'selected-option': item.selected,
              'correct-answer': nextQuiz && item.correct
            }"
            @click="!nextQuiz && handleQuizAnswer(item)"
          >
            <p style="margin: 0px !important; word-break: break-all;">
              {{ item.value }}
            </p>
          </div>
        </div>
      </div>

      <!-- NEXT BUTTON -->
      <div class="next-btn-wrapper">
        <button
          class="next-btn"
          :class="{ active: nextQuiz }"
          :disabled="!nextQuiz"
          @click="handleNextQuestion"
          style="padding: 15px !important;"
          :style="{
            fontSize: isLast ? '20px' : '25px'
          }"
        >
          {{ isLast ? "Submit" : ">" }}
          <!-- > -->
        </button>
      </div>
    </div>

    <!-- BOTTOM LOGO -->
    <div v-if="isLogoVisible" class="bottom-logo">
      <img :src="logoUrl" />
    </div>

    <!-- Exit Modal for old design -->
    <div
      class="modal fade exit-quiz-modal show"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
      style="padding-right: 17px; display: block;"
      v-if="this.$store.state.showExitModal"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="position: absolute; left: 48%; top: 55%; transform: translate(-50%, -50%); width: 85%;"
      >
        <div
          :style="{
            backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
            color: '#000000',
            borderRadius: '20px'
          }"
          class="modal-content"
          style="margin-left: -6px;"
        >
          <div
            class="modal-body"
            style="padding-top: 15px !important; padding-left: 15px !important; padding-right: 15px !important;"
          >
            <!-- <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal()"
              >
                X
              </button> -->
            <div
              :style="{ color: bgTheme }"
              style="display: flex; justify-content: flex-end; cursor: pointer; "
              @click="closeModal()"
            >
              <!-- <close-icon @click="closeModal()" /> -->
              X
            </div>
            <div
              :style="{ fontWeight: '600', marginTop: '5px' }"
              class="modal-title"
            >
              <span style="color: #000000; font-size: 14px;"
                >Are you sure, you want to Exit</span
              >
            </div>
            <p style="font-size: 12px;">
              You will lose your Score and won't be able to rejoin this Quiz.
            </p>

            <div style="margin-top: 15px;">
              <button
                :style="{
                  backgroundColor: isDarkTheme ? topBgColor : bgTheme,
                  color: '#ffffff',
                  padding: '5px 20px',
                  border: 'none',
                  borderRadius: '20px'
                }"
                @click="exitQuiz()"
              >
                Exit
              </button>
              <button
                :style="{
                  backgroundColor: isDarkTheme ? topBgColor : bgTheme,
                  color: '#ffffff',
                  padding: '5px 20px',
                  border: 'none',
                  borderRadius: '20px'
                }"
                @click="closeModal()"
              >
                Continue Quiz
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ***** OLD DESIGN ***** -->
  <!-- Replace your OLD DESIGN block with this corrected version -->
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      paddingTop: '20px',
      position: 'relative',
      minHeight: '100vh',
      height: 'auto'
    }"
    class="content"
    v-else
  >
    <QuizHeader />
    <div
      :style="{ background: isDarkTheme ? topBgColor : bgTheme }"
      style="height: 200px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;"
    ></div>
    <div
      class="container-fluid"
      style="margin-top: -140px; margin-left: 10px; margin-right: 10px"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
          borderRadius: '15px'
        }"
        class="quiz-question-section common-block margin-vertical-10"
      >
        <div class="circle-timer-section" style="z-index: 5">
          <div class="timer">
            <div class="question_timer is-countdown">
              <span
                class="countdown-row countdown-amount"
                style="margin-top: 1.25rem;"
              >
                <!-- {{ Math.floor(qtime / 1000 / 60) }}m:{{ (qtime / 1000) % 60 }}s -->
                {{ Math.floor(Math.max(0, qtime) / 1000 / 60) }}m:{{
                  Math.floor((Math.max(0, qtime) / 1000) % 60)
                }}s
              </span>
            </div>
          </div>
        </div>
        <div class="title border-bottom text-center" style="margin-top: 40px">
          <span>Question {{ quizNo + 1 }}/{{ quizData.length }}</span>
        </div>

        <div class="question-block">
          <p>{{ quizData[quizNo] ? quizData[quizNo].question : "" }}</p>

          <!-- ✅ FIXED: Now matches new design functionality -->
          <div
            style="background-color: #ffffff; word-break: break-all;"
            v-for="(item, index) in currentQuizQuest"
            :key="index"
            :class="[
              'options-block',
              item.selected ? 'selected-option' : '',
              nextQuiz && item.correct ? 'correct-answer' : ''
            ]"
            @click="!nextQuiz && handleQuizAnswer(item)"
          >
            <span>{{ item.key }}</span>
            <p>{{ item.value }}</p>
          </div>

          <div class="confirmation-btn text-center">
            <a
              style="padding: 5px 30px !important;"
              :style="{
                backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
                color: isDarkTheme ? headingTextColor : '#ffffff',
                cursor: nextQuiz ? 'pointer' : 'not-allowed',
                borderRadius: '40px',
                opacity: nextQuiz ? 1 : 1
              }"
              :class="[
                !nextQuiz ? 'disabled' : '',
                'btn btn-pink btn-uppercase btn-font-big'
              ]"
              role="button"
              @click="handleNextQuestion()"
            >
              {{ isLast ? "SUBMIT" : "NEXT" }}
              <!-- > -->
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Exit Modal for old design -->
    <div
      class="modal fade exit-quiz-modal show"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-modal="true"
      role="dialog"
      style="padding-right: 17px; display: block;"
      v-if="this.$store.state.showExitModal"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="position: absolute; left: 48%; top: 55%; transform: translate(-50%, -50%); width: 85%;"
      >
        <div
          :style="{
            backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
            color: '#000000',
            borderRadius: '20px'
          }"
          class="modal-content"
          style="margin-left: -6px;"
        >
          <div
            class="modal-body"
            style="padding-top: 15px !important; padding-left: 15px !important; padding-right: 15px !important;"
          >
            <!-- <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal()"
              >
                X
              </button> -->
            <div
              :style="{ color: bgTheme }"
              style="display: flex; justify-content: flex-end; cursor: pointer;"
              @click="closeModal()"
            >
              <!-- <close-icon @click="closeModal()" /> -->
              X
            </div>
            <div
              :style="{ fontWeight: '600', marginTop: '5px' }"
              class="modal-title"
            >
              <span style="color: #000000; font-size: 14px;"
                >Are you sure, you want to Exit</span
              >
            </div>
            <p style="font-size: 12px;">
              You will lose your Score and won't be able to rejoin this Quiz.
            </p>

            <div style="margin-top: 15px;">
              <button
                :style="{
                  backgroundColor: isDarkTheme ? topBgColor : bgTheme,
                  color: '#ffffff',
                  padding: '5px 20px',
                  border: 'none',
                  borderRadius: '20px'
                }"
                @click="exitQuiz()"
              >
                Exit
              </button>
              <button
                :style="{
                  backgroundColor: isDarkTheme ? topBgColor : bgTheme,
                  color: '#ffffff',
                  padding: '5px 20px',
                  border: 'none',
                  borderRadius: '20px'
                }"
                @click="closeModal()"
              >
                Continue Quiz
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";
import QuizHeader from "@/components/quiz-header";
import axios from "axios";
import quizBackgroundImage from "@/assets/quiz-bg-img.png";
import { height } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import BackIcon from "@/components/back-icon.vue";
import CloseIcon from "@/components/close-icon.vue";

export default {
  mixins: [globals],
  // name: "quiz-questions",
  props: {
    date: {
      type: String
    }
  },
  components: {
    QuizHeader,
    BackIcon,
    CloseIcon
  },
  data() {
    return {
      quizBackgroundImage,
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      distance: 3600000,
      question_time: 0,
      qtime: 0,
      time_bonus: 0,
      currentQuizQuest: [],
      nextQuiz: false,
      quizNo: 0,
      game_id: null,
      quizData: [],
      answers: [],
      currentQuestion: null,
      correctAnswersCount: 0,
      final_screen_data: [],
      isNewDesign: true,
      bannerUrl: "",
      backgroundImage: "",
      // bgTheme: "",
      showExitModal: false,
      isLogoVisible: false,
      logoUrl: ""
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.offersCardBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    showExitModal() {
      return this.$store.state.showExitModal;
    },

    sdkEvent() {
      return this.$store.state.sdkEvent;
    },
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
    isLast() {
      return this.quizNo === this.quizData.length - 1;
    }
  },
  methods: {
    handleBack() {
      console.log("HAnlde..", this.isNewDesign);
      if (this.isNewDesign) {
        console.log("sdsdsdsd....");
        this.showExitModal = true;
        this.$store.state.showExitModal = true;
      } else {
        this.$store.state.showExitModal = true;
        this.showExitModal = true;
      }
      // this.showExitModal = true
    },
    closeModal() {
      // this.showExitModal = false
      // this.$store.state.showExitModal = false;
      if (this.isNewDesign) {
        this.showExitModal = false;
        this.$store.state.showExitModal = false;
      } else {
        this.$store.state.showExitModal = false;
        this.showExitModal = false;
      }
    },
    exitQuiz() {
      this.$router.go(-2);
    },
    // showRemaining() {
    //   const timer = setInterval(() => {
    //     if (this.qtime < 0) {
    //       if (this.quizNo === (this.quizData.length - 1)) {
    //         clearInterval(timer)
    //       }
    //       // this.handleQuizAnswer()
    //       this.handleNextQuestion()
    //       return
    //     }
    //     this.qtime = this.qtime - 1000
    //   }, 1000)
    // },

    showRemaining() {
      if (this.timer) {
        clearInterval(this.timer); // prevent multiple intervals
      }

      this.timer = setInterval(() => {
        if (this.qtime < 0) {
          clearInterval(this.timer); // stop current timer

          const correctOption = this.currentQuizQuest.find(i => i.correct);
          if (correctOption && !this.nextQuiz) {
            this.handleQuizAnswer(correctOption, true);
          }

          setTimeout(() => {
            if (this.quizNo === this.quizData.length - 1) {
              this.submitAnswers();
            } else {
              this.handleNextQuestion(); // this will restart timer
            }
          }, 1000);

          return;
        }

        this.qtime -= 1000;
      }, 1000);
    },

    handleQuizAnswer(item, isAuto = false) {
      if (this.nextQuiz) return;

      item.selected = true;
      this.nextQuiz = true;

      this.answers.push({ key: item.question_id, value: item.key });

      // ✅ Only increase score if user clicked it AND it's correct
      if (item.correct && !isAuto) {
        this.correctAnswersCount += 1;
      }
    },

    // handleQuizAnswer(item, isAuto = false) {
    //   if (this.nextQuiz) return;

    //   item.selected = true;
    //   this.nextQuiz = true;

    //   this.currentQuizQuest = this.currentQuizQuest.filter(i =>
    //     i.correct ? (i.selected = true) : false && i.id == item.id ? item : i
    //   );

    //   this.answers.push({ key: item.question_id, value: item.key });

    //   // ✅ Only increase score if user clicked it
    //   if (item.correct && !isAuto) {
    //     this.correctAnswersCount += 1;
    //   }
    // },

    handleNextQuestion() {
      this.time_bonus += this.qtime;

      if (this.quizNo !== this.quizData.length - 1) {
        this.qtime = this.question_time * 1000;
      }

      if (this.quizNo === this.quizData.length - 1) {
        this.submitAnswers();
      } else {
        this.distance = this.qtime;
        this.quizNo += 1;
        this.nextQuiz = false;
        this.currentQuizQuest = this.quizData[this.quizNo].options;

        // ✅ Restart the timer for the next question
        this.showRemaining();
      }
    },

    submitAnswers() {
      const self = this;
      // ✅ FIX MISSING BONUS TIME for final question
      // this.time_bonus += this.qtime;
      const url =
        self.$store.getters.flyyDomain + "/record_score/" + self.game_id;
      const headers = self.$store.getters.headers;
      let time = self.time_bonus / 1000;
      if (time < 0) {
        time = 0;
      }
      self.$store.state.quiz_time_bonus = time;
      const body = {
        quiz_result: this.answers,
        time: time
      };

      axios
        .post(url, body, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            this.showExitModal = false;
            const data = resp.data;
            const answers_score = self.correctAnswersCount * 1000;
            const total_score = answers_score + time;
            const currentUrl = window.location.pathname;

            if (currentUrl == "/play-quiz") {
              self.$router.replace({
                name: "congrats",
                params: {
                  total_questions: self.quizData.length,
                  correct_answers: self.correctAnswersCount,
                  total_score: total_score,
                  answers_score: answers_score,
                  time_score: time,
                  final_screen_data: self.final_screen_data
                }
              });
            } else {
              this.showExitModal = false;
              self.$router.replace("quiz-zone");
            }
          } else {
            console.log("Error Submitting Answers");
          }
        });
    },
    fetchQuizQuestions() {
      const self = this;
      const url = self.$store.getters.flyyDomain + "/play_quiz/" + self.game_id;
      const headers = self.$store.getters.headers;

      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200) {
            const data = resp.data;
            if (!data.success) {
              this.$router.go(-1);
              return;
            }

            const decoded = decodeURIComponent(
              atob(data.key)
                .split("")
                .map(function(ch) {
                  return "%" + ("00" + ch.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
            );
            const c = JSON.parse(decoded);

            const apt = {};
            c.forEach(function(item) {
              apt[item["key"]] = item["value"];
            });

            const finalData = [];
            data.questions.forEach(function(item) {
              const formattedOptions = [];
              item.options.forEach(function(opt) {
                formattedOptions.push({
                  key: opt["key"],
                  value: opt["value"],
                  selected: false,
                  correct: apt[item.id] == opt["key"],
                  question_id: item.id
                });
              });
              finalData.push({
                id: item.id,
                question: item.question,
                options: formattedOptions
              });
            });

            self.quizData = finalData;
            self.question_time = data.quiz_timer;
            self.qtime = self.question_time * 1000;
            self.$store.state.final_screen_data = data.final_screen_data;
            self.currentQuizQuest = self.quizData[0].options;
            self.currentQuestion = self.currentQuizQuest[0];
            self.final_screen_data = data.final_screen_data;
            self.showRemaining();
          } else {
            console.log("Error fetching the Quiz Questions");
          }
        });
    }
  },
  created() {
    this.game_id = this.$route.params.id;
    this.$store.state.quizDetailsTitle = "";
    this.fetchQuizQuestions();
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
    this.bannerUrl = this.$route.params.banner_url;
    console.log("sdkEvent on mount:", this.sdkEvent);

    console.log(this.$store.state.sdkEvent);

    // Show custom Page condition
    if (
      this.sdkEvent.isCustomQuizPageEnabled === "true" ||
      this.sdkEvent.isCustomQuizPageEnabled === "YES"
    ) {
      this.isNewDesign = true;
    } else {
      this.isNewDesign = false;
    }

    if (this.sdkEvent.logoUrl !== "") {
      this.isLogoVisible = true;
      this.logoUrl = this.sdkEvent.logoUrl;
    } else {
      this.isLogoVisible = false;
    }
  },
  watch: {
    sdkEvent(newValue) {
      if (newValue) {
        console.log("sdkEvent is now available in watcher:", newValue);

        if (newValue.isCustomQuizPageEnabled === "true") {
          // Do your logic here
          console.log("Custom quiz page is enabled!");
        }
      }
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

/* ========= GLOBAL WRAPPER ========= */
.quiz-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

/* ========= HEADER + BANNER ========= */
.banner-wrapper {
  position: relative;
}

.quiz-title {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.quiz-close {
  /* margin-right: 16px; */
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  width: 22px;
  height: 22px;
  color: #000000;
  margin: 0px !important;
}
/* ========= WHITE BACKGROUND PNG ========= */
/* .quiz-content-bg {
  background: url("@/assets/quiz-bg-img.png") no-repeat center top;
  background-size: cover;
  padding: 30px 20px 100px;
  margin-top: -10px;
} */

/* ========= PROGRESS ROW ========= */
.quiz-progress-row {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.progress-bar-block {
  flex: 1;
  height: 2px;
  border-radius: 4px;
}

.progress-count {
  margin-left: 6px;
  font-size: 10px;
}

/* ========= OPTIONS ========= */

.selected-option {
  background: #fff3f3;
  border-color: #c7222a;
  color: #c7222a;
}

.selected-option-old {
  background: #fff3f3;
  border-color: #c7222a;
  color: #000000;
}

.correct-answer {
  background: #e8ffe8;
  border-color: #70b865;
}

/* ========= NEXT BUTTON ========= */
.next-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.next-btn {
  width: 30%;
  padding: 12px 0;
  border: none;
  border-radius: 15px;
  background: #dadada;
  color: #ffffff;
  /* opacity: 0.6; */
}

.next-btn.active {
  background: #c7222a;
  color: white;
  opacity: 1;
}

/* ========= RESPONSIVE ========= */

/* SMALL PHONES ≤360px */
@media (max-width: 360px) {
  .quiz-banner {
    width: 100%;
    /* height: 35vh; */
    height: 40vh;
    /* object-fit: cover; */
    object-fit: fill;
  }

  .quiz-header-new-1 {
    background: transparent !important;
    /* position: absolute; */
    position: fixed;
    top: 0;
    left: 0;
    width: 93%;
    padding: 12px 12px 0px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
  }

  .quiz-content-bg {
    padding: 20px 14px 20px;
    background-size: cover;
    position: relative;
    bottom: 20px;
    width: 91%;
  }

  .question-block-new p {
    font-size: 14px;
  }

  /* .options-block-new {
    padding: 10px;
    font-size: 13px;
  } */

  .next-btn {
    width: 33%;
    border-radius: 35px !important;
  }

  /* ========= BOTTOM LOGO ========= */
  .bottom-logo {
    display: flex;
    justify-content: center;
    /* margin-top: 20px; */
    padding-bottom: 20px;
    /* position: fixed; */
    /* bottom: 0vh; */
    /* left: 43%; */
  }

  .bottom-logo img {
    width: 40px;
    height: 40px;
  }

  .options-block-new {
    background: #f4f4f4;
    /* padding: 14px; */
    border-radius: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border: 1px solid transparent;
    cursor: pointer;
    word-wrap: break-word;
  }
  /* ========= QUESTION BLOCK ========= */
  .question-block-new {
    margin-top: 0px !important;
    padding: 0px !important;
  }

  .question-text {
    margin: 15px 0px !important;
  }

  .question-block-new p {
    text-align: left;
    font-size: 13px;
  }

  .options-block-new p {
    font-size: 12px;
  }

  .timer-box p {
    margin: 0;
    color: white;
    font-size: 9px;
  }

  .timer-box {
    display: flex;
    gap: 4px;
    align-items: center;
    background: #999;
    padding: 4px 6px;
    border-radius: 6px;
    width: 50px;
  }

  .timer-box img {
    width: 10px;
    height: 10px;
  }
}

/* NORMAL PHONES 361px–480px */
@media (min-width: 361px) and (max-width: 480px) {
  .quiz-banner {
    width: 100%;
    height: 35vh;
    /* object-fit: cover; */
    object-fit: inherit;
  }

  .quiz-header-new-1 {
    background: transparent !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 93%;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
  }

  .quiz-content-bg {
    padding: 20px 14px 20px;
    background-size: cover;
    position: relative;
    bottom: 6vh;
    width: 93%;
  }
  /* ========= QUESTION BLOCK ========= */
  .question-block-new p {
    font-size: 14px;
  }

  .next-btn {
    width: 30%;
    border-radius: 35px;
  }

  /* ========= BOTTOM LOGO ========= */
  .bottom-logo {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding-bottom: 20px;
  }

  .bottom-logo img {
    width: 60px;
    height: 60px;
  }

  .options-block-new {
    background: #f4f4f4;
    /* padding: 14px; */
    border-radius: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border: 1px solid transparent;
    cursor: pointer;
    word-wrap: break-word;
    padding: 14px 10px;
    font-size: 13px;
  }
  /* ========= QUESTION BLOCK ========= */
  .question-block-new {
    margin-top: 0px !important;
    padding: 0px !important;
  }

  .question-text {
    margin: 15px 0px !important;
  }

  .question-block-new p {
    text-align: left;
    font-size: 13px;
  }

  .options-block-new p {
    font-size: 12px;
  }

  .timer-box {
    display: flex;
    gap: 4px;
    align-items: center;
    background: #999;
    padding: 4px 6px;
    border-radius: 6px;
    width: 80px;
  }

  .timer-box p {
    margin: 0;
    color: white;
    font-size: 13px;
  }

  .timer-box img {
    width: 20px;
    height: 23px;
  }

  .quiz-wrapper {
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
  }
}
</style>
